import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { UserProfile } from '@models/userProfile';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { AuthenticationService } from '@services/authentication/authentication.service';
import { AuthState } from '@state/auth';
import { AuthUser } from '@state/auth/auth.models';
import { BusinessState } from '@state/business';
import { UserProfileState } from '@state/user-profile';
import LogRocket from 'logrocket';
import { first } from 'rxjs/operators';
import { CreateMatterModalComponent } from 'src/app/private/create-matter/modal/modal.component';
import { SnackbarService } from 'src/app/shared/services/ui/snackbar.service';
import { multipleEmailsValidator } from 'src/app/shared/validators/multiple-emails.validator';

@Component({
	selector: 'app-invite-modal',
	templateUrl: './invite-modal.component.html',
	styleUrls: ['./invite-modal.component.scss'],
	standalone: false,
})
export class InviteModalComponent implements OnInit {
	public validatorFn = multipleEmailsValidator();
	public emails: FormControl;

	@SelectSnapshot(UserProfileState.getCurrentBusinessId) businessId: string;
	@SelectSnapshot(BusinessState.businessName) businessName: string;
	@SelectSnapshot(AuthState.getLoggedInUser) user: AuthUser;
	@SelectSnapshot(UserProfileState.getProfile) userProfile: UserProfile;

	constructor(
		public dialogRef: MatDialogRef<CreateMatterModalComponent>,
		private snackbarService: SnackbarService,
		private authenticationService: AuthenticationService,
	) {}

	ngOnInit(): void {
		this.emails = new FormControl([], Validators.email);
	}

	public close(): void {
		this.dialogRef.close();
	}

	public async submitEmails(): Promise<void> {
		if (this.emails.value.length && this.emails.valid) {
			await this.createInvites(this.emails.value);
			this.dialogRef.close();
		}
	}

	async createInvites(emails: string[]): Promise<void> {
		this.authenticationService
			.createInvites(
				emails,
				`${this.userProfile.firstName} ${this.userProfile.lastName}`,
				this.businessName,
			)
			.pipe(first())
			.subscribe(
				() => {
					this.snackbarService.openSnackBar({
						text: 'Invite(s) sent!',
						type: 'success',
					});
				},
				(err) => {
					LogRocket.captureException(err, {
						extra: {
							emails: emails.join(', '),
						},
					});

					this.snackbarService.openSnackBar({
						text: 'Uh oh! We were unable to send invite(s). If problem persists please reach out',
						type: 'error',
					});
				},
			);
	}
}
